<template>
    <div v-if="startImport"
      class="file-uploader"
      style="color: #fff; background-color: rgb(43, 45, 51)"
    >
      <!-- 上传区域 -->
      <div
        class="upload-area"
        @click="$refs.fileInput.click()"
        @dragover.prevent
        @drop.prevent="handleDrop"
      >
        <input
          ref="fileInput"
          type="file"
          :accept="accept"
          :multiple="multiple"
          class="hidden-input"
          @change="handleFileChange"
        />
  
        <v-icon :icon="icon" color="primary" size="48" />
  
        <div class="text-h6 mt-4">
          {{ files?.length ? "点击或拖拽excel文件" : "点击或拖拽excel文件" }}
        </div>
  
        <div
          class="text-body-2 text-medium-emphasis mt-2"
          style="color: rgba(255, 255, 255, 0.26) !important"
        >
          <!-- {{ acceptText }}
          <br /> -->
          {{ multiple ? "可同时上传多个文件或图片" : "请选择一个excel文件" }}
          <br />
          文件大小限制：20MB
          <br />
          建议使用 Chrome、Edge、Safari 浏览器
          <br />
            上传的表格需遵循以下规范：
            <div style="text-align: left;padding-left: 60px;">
            1、导入的内容区域，不可存在合并单元格
            <br />
            2、图片需要完整的在格子中，不可超出格子边框
            <br />
            3、每一列信息是相同的类型
            </div>
        </div>
      </div>
      <!-- <input v-if="type === 0" v-model="row" style="width: 100%;height: 40px;border: 1px solid #fff;border-radius: 4px;margin-top: 12px;padding: 0 12px;box-sizing: border-box;color: #fff;" type="number" placeholder="请输入表头所在行" @change="handleFileChange" /> -->
      <!-- 文件列表 -->
      <v-list v-if="files?.length" class="file-list mt-4" color="#2B2D33">
        <v-list-item
          v-for="(file, index) in files"
          :key="index"
          class="file-item"
          color="#3A3B3F"
        >
          <template v-slot:prepend>
            <v-icon
              :color="isValidFile(file) ? 'primary' : 'error'"
              :icon="isValidFile(file) ? 'mdi-file' : 'mdi-file-alert'"
            />
          </template>
  
          <v-list-item-title>
            {{ file.name }}
          </v-list-item-title>
  
          <v-list-item-subtitle>
            {{ formatFileSize(file.size) }}
            <span v-if="!isValidFile(file)" class="text-error">
              - {{ !isValidFileSize(file) ? '文件超过20MB限制' : '不支持的文件格式' }}
            </span>
          </v-list-item-subtitle>
  
          <template v-slot:append>
            <v-btn
              icon="mdi-close"
              variant="text"
              size="small"
              @click="removeFile(index)"
            />
          </template>
        </v-list-item>
      </v-list>
  
      <!-- 上传进度 -->
      <!-- <div v-if="uploading" class="progress-container mt-4">
        <div class="d-flex align-start">
          <v-icon icon="mdi-cloud-upload" color="primary" class="mr-2" />
          <div class="progress-info">
            正在上传 {{ uploadedCount }}/{{ totalCount }} ({{
              Math.round(uploadProgress)
            }}%)
          </div>
        </div>
      </div> -->
  
      <!-- 错误提示 -->
      <v-alert
        v-if="error"
        type="error"
        variant="tonal"
        class="mt-4"
        closable
        @click:close="clearError"
      >
        {{ error }}
      </v-alert>
  
      <!-- 底部操作栏 -->
      <div class="d-flex justify-end mt-4">
        <v-btn
          color="error"
          variant="tonal"
          :disabled="uploading"
          @click="handleClose"
          style="margin-right: 16px"
        >
          取消
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          :loading="uploading"
          @click="handleUpload"
        >
          <template v-if="uploading">
            {{ uploadedCount }}/{{ totalCount }} ({{
              Math.round(uploadProgress)
            }}%)
          </template>
          <template v-else> 开始上传 </template>
        </v-btn>
      </div>
    </div>
    <!-- <div v-else
      class="file-uploader"
      style="color: #fff; background-color: rgb(43, 45, 51);"
    >
      <div style="font-size: 20px;font-weight: 600;margin-bottom: 12px;">选择要导入的sheet</div>
      <div class="sheet-list" style="display: flex;flex-wrap: wrap;overflow: auto;height: 70vh;">
        <v-checkbox style="width: 33%;" v-for="(item, index) in sheetList" :key="index" :data-value="item.sheetIndex" :label="item.sheetName" @change="handleSheetChange(item.sheetIndex)" />
      </div>

      <v-alert
        v-if="error"
        type="error"
        variant="tonal"
        class="mt-4"
        closable
        @click:close="clearError"
      >
        {{ error }}
      </v-alert>
  
      <div class="d-flex justify-end mt-4">
        <v-btn
          color="error"
          variant="tonal"
          :disabled="uploading"
          @click="handleClose"
          style="margin-right: 16px"
        >
          取消
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          :loading="uploading"
          @click="handleChooseUpload"
        >
          确定
        </v-btn>
      </div>
    </div> -->
  </template>
    
    <script setup lang="ts">
  import { ref, computed } from "vue";
  import { uploadApi, contractApi } from "@/services/api";
  import { useSnackbar } from '@/composables/useSnackbar'
  const { showError } = useSnackbar()
  const props = withDefaults(defineProps<{
    accept?: string;
    multiple?: boolean;
    icon?: string;
    acceptText?: string;
    title?: string;
    type?: number;
  }>(), {
    accept: '.xls,.xlsx',
    multiple: false,
    icon: 'mdi-file-excel',
    acceptText: '支持Excel格式 (.xls, .xlsx)'
  });
  
  const emit = defineEmits<{
    (e: "uploadExcel", files: { url: string; name: string }[]): void;
    (e: "importStart"): void;
    (e: "close"): void;
  }>();
  
  const fileInput = ref<HTMLInputElement | null>(null);
  const files = ref<File[] | null>(null);
  const uploading = ref(false);
  const uploadProgress = ref(0);
  const error = ref<string | null>(null);
  const uploadedCount = ref(0);
  const totalCount = ref(0);
  const row = ref(null);
  const sheetList = ref<any[]>([]);
  const startImport = ref(true);
  const sheetIndexList = ref<number[]>([]);
  const tempnewUploadedUrls = ref<any[]>([]);
  
  // 是否可以上传
  const canUpload = computed(() => {
    if (!files.value?.length || !row.value) return false;
    return files.value.every((file) => isValidFile(file));
  });
  
  // 验证文件类型
  const isValidFileType = (file: File) => {
    if (!props.accept) return true;
    const acceptedTypes = props.accept.split(",").map((type) => type.trim());
    console.log('验证文件类型:', file.name, file.type, '接受类型:', acceptedTypes);
    const isValid = acceptedTypes.some((type) => {
      if (type.startsWith(".")) {
        const result = file.name.toLowerCase().endsWith(type.toLowerCase());
        console.log(`检查扩展名 ${type}: ${result}`);
        return result;
      }
      const result = file.type.match(type);
      console.log(`检查MIME类型 ${type}: ${result}`);
      return result;
    });
    console.log('文件类型验证结果:', isValid);
    return isValid;
  };

  // 验证文件大小（限制20MB）
  const isValidFileSize = (file: File) => {
    const maxSize = 20 * 1024 * 1024; // 20MB
    const isValid = file.size <= maxSize;
    console.log('验证文件大小:', file.name, formatFileSize(file.size), '限制:', formatFileSize(maxSize), '结果:', isValid);
    return isValid;
  };

  // 验证文件（类型和大小）
  const isValidFile = (file: File) => {
    const typeValid = isValidFileType(file);
    const sizeValid = isValidFileSize(file);
    const overallValid = typeValid && sizeValid;
    console.log('文件整体验证:', file.name, '类型:', typeValid, '大小:', sizeValid, '总体:', overallValid);
    return overallValid;
  };
  
  // 格式化文件大小
  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };
  
  // 处理sheet选择
  const handleSheetChange = (sheetIndex: number) => {
    if (sheetIndexList.value.includes(sheetIndex)) {
      sheetIndexList.value = sheetIndexList.value.filter(index => index !== sheetIndex);
    } else {
      sheetIndexList.value.push(sheetIndex);
    }
  };

  // 处理文件选择
  const handleFileChange = (event: Event) => {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const selectedFiles = Array.from(input.files);
      // 过滤掉超过20MB的文件
      const validFiles = selectedFiles.filter(file => isValidFile(file));
      
      if (validFiles.length !== selectedFiles.length) {
        const invalidFiles = selectedFiles.filter(file => !isValidFile(file));
        const oversizedFiles = invalidFiles.filter(file => !isValidFileSize(file));
        if (oversizedFiles.length > 0) {
          error.value = `单次表格上传不可超过20兆，可删除表格中的无用图片，或分次上传`;
        }
      }else{
          error.value = null;
          startImport.value = true;
          uploading.value = false;
          row.value = null;
          sheetList.value = [];
          sheetIndexList.value = [];
          tempnewUploadedUrls.value = [];
          uploadProgress.value = 0;
          uploadedCount.value = 0;
          totalCount.value = 0;
        }
      
      files.value = validFiles;
    }
  };
  
  // 处理拖放
  const handleDrop = (event: DragEvent) => {
    const droppedFiles = event.dataTransfer?.files;
    if (droppedFiles) {
      const selectedFiles = Array.from(droppedFiles);
      // 过滤掉超过20MB的文件
      const validFiles = selectedFiles.filter(file => isValidFile(file));
      
      if (validFiles.length !== selectedFiles.length) {
        const invalidFiles = selectedFiles.filter(file => !isValidFile(file));
        const oversizedFiles = invalidFiles.filter(file => !isValidFileSize(file));
        if (oversizedFiles.length > 0) {
          // error.value = `以下文件超过20MB限制：${oversizedFiles.map(f => f.name).join(', ')}`;
          error.value = `单次表格上传不可超过20兆，可删除表格中的无用图片，或分次上传`;
        }
      }else{
        error.value = null;
        startImport.value = true;
        uploading.value = false;
        row.value = null;
        sheetList.value = [];
        sheetIndexList.value = [];
        tempnewUploadedUrls.value = [];
        uploadProgress.value = 0;
        uploadedCount.value = 0;
        totalCount.value = 0;
      }
      
      files.value = validFiles;
    }
  };
  
  // 移除文件
  const removeFile = (index: number) => {
    if (files.value) {
      files.value.splice(index, 1);
      if (files.value.length === 0) {
        files.value = null;
      }
    }
  };
  
  // 清除错误并重置状态
  const clearError = () => {
    error.value = null;
    startImport.value = true;
    uploading.value = false;
    files.value = null;
    row.value = null;
    sheetList.value = [];
    sheetIndexList.value = [];
    tempnewUploadedUrls.value = [];
    uploadProgress.value = 0;
    uploadedCount.value = 0;
    totalCount.value = 0;
  };
  
  // 处理关闭
  const handleClose = () => {
    if (uploading.value) return;
    clearError();
    // 通知父组件关闭弹窗
    emit("close");
  };
  
  // 处理上传
  const handleUpload = async () => {
    // if (!files.value || !canUpload.value || !row.value) return;
    if(!files.value){
      // error.value = '请先上传文件'
      showError('请先上传文件')
      return
    }
    error.value = null
    uploading.value = true;
    uploadProgress.value = 0;
    uploadedCount.value = 0;
    totalCount.value = files.value.length;
    
    try {
      console.log("开始上传文件:", files.value);
      // 使用新的批量上传接口
      const uploadedUrls = await uploadApi.uploadFiles(
        files.value,
        (progress) => {
          uploadProgress.value = progress;
          console.log("总体上传进度:", progress);
        },
        (fileIndex, progress) => {
          // 当一个文件完成上传时更新计数
          if (progress === 100) {
            uploadedCount.value = fileIndex + 1;
          }
          if (files.value) {
            console.log(
              `文件 ${files.value[fileIndex].name} 上传进度: ${progress}%`
            );
          }
        }
      );
      var newUploadedUrls = [];
      for (let i = 0; i < uploadedUrls.length; i++) {
        newUploadedUrls.push({
          url: uploadedUrls[i],
          name: files.value[i].name,
        });
      }
      console.log("文件上传完成，URLs:", uploadedUrls,row.value);
      // 发送上传完成的事件
      console.log('newUploadedUrls', newUploadedUrls)
      tempnewUploadedUrls.value = newUploadedUrls

      // 通知父组件开始导入
      emit("importStart");
      emit("uploadExcel", newUploadedUrls);
      // 清理状态
      files.value = null;
      sheetList.value = []
      // 通知父组件关闭弹窗
      emit("close");

      // try{
      //   const res = await contractApi.getExcelSheetList({
      //     excelUrl: newUploadedUrls[0].url,
      //     row: row.value
      //   });
      //   if(res?.code === 0){
      //     sheetList.value = res.data
      //     if(res.data.length > 1){
      //       startImport.value = false
      //     }else{
      //       let sheetIndexList = ['0']
      //       // 通知父组件开始导入
      //       emit("importStart");
      //       emit("uploadExcel", newUploadedUrls, row.value, props.type, sheetIndexList);
      //       // 清理状态
      //       files.value = null;
      //       sheetList.value = []
      //       // 通知父组件关闭弹窗
      //       emit("close");
      //     }
      //   }else{
      //     error.value = res?.message || "上传失败，请重试";
      //   }
      // }catch(err:any){
      //   console.error("上传过程发生错误:", err);
      //   error.value = err.message || "上传失败，请重试";
      // }
    } catch (err: any) {
      console.error("上传过程发生错误:", err);
      error.value = err.message || "上传失败，请重试";
    } finally {
      uploading.value = false;
      uploadProgress.value = 0;
      uploadedCount.value = 0;
      totalCount.value = 0;
    }
  };

  const handleChooseUpload = () => {
    if(sheetIndexList.value.length === 0){
      // error.value = '请先选择要导入的sheet'
      showError('请先选择要导入的sheet')
      return
    }
    error.value = null
    console.log('sheetIndexList', sheetIndexList.value)
    // 通知父组件开始导入
    emit("importStart");
    emit("uploadExcel", tempnewUploadedUrls.value, row.value, props.type, sheetIndexList.value);
    // 清理状态
    files.value = null;
    sheetList.value = []
    // 通知父组件关闭弹窗
    emit("close");
  };
  </script>
    
  <style scoped>
  .file-uploader {
    background-color: #2b2d33;
    border-radius: 8px;
    padding: 20px;
  }
  
  .sheet-list::-webkit-scrollbar {
    width: 6px;
  }

  .sheet-list::-webkit-scrollbar-track {
    background: transparent;
  }

  .sheet-list::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }

  .sheet-list::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }

  .upload-area {
    border: 2px dashed rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    padding: 40px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s;
  }
  
  .upload-area:hover {
    border-color: var(--v-theme-primary);
  }
  
  .hidden-input {
    display: none;
  }
  
  .file-list {
    border-radius: 8px;
    overflow: hidden;
  }
  
  .file-item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
  
  .file-item:last-child {
    border-bottom: none;
  }
  
  .progress-container {
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: 12px;
  }
  
  .progress-info {
    color: rgba(255, 255, 255, 0.7);
  }
  
  .file-list {
    border-radius: 8px;
    overflow: hidden;
    background-color: #3a3b3f !important;
  }

  .v-list-item-title{
    color:rgba(255, 255, 255, 0.7) !important
  }
  
  .v-list-item-subtitle{
    color:rgba(255, 255, 255, 0.26) !important
  }
  </style>